import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { LocalitySelect, Organisation, StoreProfile, StoreSelect } from '@portal-front-end/models';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Update } from '@ngrx/entity';

@Injectable({ providedIn: 'root' })

export class OrganisationsApiService {

    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly ORGANISATION_API_URL = `${this.apiServer}/organisations`;

    getOrganisations(parentOrgId: string): Observable<Organisation[]> {
        return this.http.get<Organisation[]>(`${this.ORGANISATION_API_URL}`, {
            params: {
                'parentOrganisationId': parentOrgId
            }
        });
    }
    getAllStatus(): Observable<Organisation[]> {
        return this.http.get<Organisation[]>(`${this.ORGANISATION_API_URL}/search`, {
            params: { 'organisationTypeId': '5' }
        });
    }
    getAllStores(): Observable<Organisation[]> {
        return this.http.get<Organisation[]>(`${this.ORGANISATION_API_URL}/search`, {
            params: { 'organisationTypeId': '5' }
        });
    }

    getAllSuppliers(): Observable<Organisation[]> {
        return this.http.get<Organisation[]>(`${this.ORGANISATION_API_URL}/search`, {
            params: { 'organisationTypeId': '3' }
        });
    }

    putOrganisations(payload: Update<Organisation>): Observable<Organisation> {
        return this.http.put<Organisation>(`${this.ORGANISATION_API_URL}/${payload.changes.organisationId}`, payload.changes);
    }

    getStoresForSearchTerm(searchTerm: string): Observable<StoreSelect[]> {
        return this.http.get<StoreSelect[]>(`${this.ORGANISATION_API_URL}/stores/select`, {
            params: { orgNameOrPostcode: searchTerm }
        });
    }

    getLocalitiesForSearchTerm(searchTerm: string): Observable<LocalitySelect[]> {
        return this.http.get<LocalitySelect[]>(`${this.apiServer}/locality-select`, {
            params: { localityOrPostcode: searchTerm }
        });
    }

    checkIfShortCodeExists(shortCode: string): Observable<boolean> {
        return this.http.get<boolean>(`${this.ORGANISATION_API_URL}/short-code-exists`, {
            params: { shortCode: shortCode }
        });
    }

    clearAccount(org: Organisation): Observable<Organisation> {
        return this.http.put<Organisation>(`${this.ORGANISATION_API_URL}/${org.organisationId}`, org);
    }

    // ...Get all stores with their address, locality and state details. 
    getStoreDetails(): Observable<StoreProfile[]> {
        return this.http.get<StoreProfile[]>(`${this.ORGANISATION_API_URL}/stores/details`)
    }

}
